const styles = () => ({
  root: {},
  options: {
    display: 'flex',
    flexDirection: 'column',
  },

  option: {
    display: 'flex',
    position: 'relative',
    '&:hover .remove': {
      display: 'inline',
      cursor: 'pointer',
    },
  },

  newForm: {
    marginTop: '15px',
  },
  grabHandleAdornment: {
    marginRight: 30,
    '& svg path': {
      fill: '#666',
    },
  },
  dragHandle: {
    backgroundRepeat: 'none',
    cursor: 'row-resize',
    height: 10,
    left: 10,
    marginTop: -5,
    position: 'absolute',
    top: '50%',
    width: 17,
    zIndex: 1,
  },
  add: {
    color: '#5786d7',
    fontSize: '15px',
    marginTop: '15px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  remove: {
    backgroundRepeat: 'none',
    cursor: 'row-resize',
    display: 'none',
    height: 18,
    position: 'absolute',
    right: '0%',
    top: '50%',
    width: 18,
    zIndex: 1,
  },
});
export default styles;
